import { BaseService } from "../base.service";
import { ErrorWrapper, ResponseWrapper } from "../util";

export class CrawlerService extends BaseService {
    static get entity() {
        return "multiplepages"
    }

    static apiClient(options) {
        const baseURL = process.env.VUE_APP_API_URL;
        return this.initApiClient({ baseURL, ...options });
    }

    static async crawlerRun(params = {}) {
        console.log(params)
        // params
        try {
            const response = await this.apiClient().get('crawler/run', { params });
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            const message = error.response.data ? error.response.data.error : error.response.statusText;
            throw new ErrorWrapper(error, message);
        }
    }

}